import PricingCard from './PricingCard'
import { useLocation } from 'react-router-dom'

export default function Pricing() {
  const location = useLocation()
  const isTaxAssist = location.pathname.includes('/tax-assist')

  const freeTierFeatures = isTaxAssist ? [
    "Executive Summary",
    "Technical Overview",
    "Partial Readiness Checklist (40+ items)",
    "Gap Analysis Worksheet",
    "Security & Data Protection Guidance",
    "Roadmap (30/60/90 → 6 → 12 months)",
    "Partial AI Copilot Playbooks",
    "Machine-readable schemas (subset)",
    "Self-healing & QA patterns (partial)"
  ] : [
    "Executive Summary",
    "Technical Overview",
    "Partial Readiness Checklist",
    "Gap Analysis Worksheet",
    "Security & Governance Guidance",
    "Roadmap (30/60/90 → 6 → 12 months)",
    "Partial AI Copilot Playbooks",
    "Machine-readable schemas (subset)",
    "Self-healing & QA patterns (partial)"
  ]

  const professionalFeatures = isTaxAssist ? [
    "Full 100+ item readiness checklist",
    "Complete AI copilot playbooks for tax workflows",
    "Form processing guides (Form 1099-DA, K-1s, etc.)",
    "Client communication templates",
    "Workflow automation scripts",
    "Full schema suite (JSON & YAML)",
    "Quality assurance checklists",
    "Practice workflow documentation",
    "Integration architecture for tax software"
  ] : [
    "Full 80–120 item checklist",
    "Complete Copilot/Cursor/Claude Code playbooks",
    "Secure submission bundle templates",
    "Reproducibility kits",
    "Proposal template (fully editable)",
    "Full schema suite (JSON & YAML)",
    "12-month roadmap",
    "Example partner pitch materials",
    "Internal governance binder templates",
    "Enterprise documentation templates",
    "Genesis Ready internal statement"
  ]

  return (
    <section id="pricing" className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            One-Time Purchase – $199 per Organization
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-4">
            {isTaxAssist 
              ? 'Includes readiness checklists, form processing guides, client communication templates, and AI copilot playbooks.'
              : 'Includes complete compliance toolkit, automation scripts, and developer-ready assets.'}
          </p>
          <p className="text-sm text-gray-500 max-w-2xl mx-auto">
            Licensed for use by one organization. No subscriptions. Free updates for all 2025 revisions.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <PricingCard
            title="Free Tier"
            price="$0"
            description="Open source on GitHub"
            features={freeTierFeatures}
            ctaText="Get on GitHub"
            ctaLink="https://github.com/gentlyventures/harboragent"
            isPrimary={false}
          />
          <PricingCard
            title="Professional Pack"
            price="$199"
            priceSubtext="One-Time"
            description={isTaxAssist ? "Complete toolkit for tax preparers" : "Complete toolkit for enterprise teams"}
            features={professionalFeatures}
            ctaText="Buy for $199"
            ctaLink="#"
            isPrimary={true}
            isProfessional={true}
          />
        </div>
        
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Both tiers help you:
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-700">
            {isTaxAssist ? (
              <>
                <span className="px-4 py-2 bg-gray-100 rounded-full">Evaluate practice readiness</span>
                <span className="px-4 py-2 bg-gray-100 rounded-full">Understand 2025 tax changes</span>
                <span className="px-4 py-2 bg-gray-100 rounded-full">Run AI-powered audits</span>
                <span className="px-4 py-2 bg-gray-100 rounded-full">Modernize workflows</span>
                <span className="px-4 py-2 bg-gray-100 rounded-full">Prepare for filing season</span>
              </>
            ) : (
              <>
                <span className="px-4 py-2 bg-gray-100 rounded-full">Evaluate current systems</span>
                <span className="px-4 py-2 bg-gray-100 rounded-full">Understand Genesis patterns</span>
                <span className="px-4 py-2 bg-gray-100 rounded-full">Run AI-powered audits</span>
                <span className="px-4 py-2 bg-gray-100 rounded-full">Align data & models</span>
                <span className="px-4 py-2 bg-gray-100 rounded-full">Prepare documentation</span>
              </>
            )}
          </div>
          <p className="mt-8 text-sm text-gray-500 italic">
            Buying this pack helps support future Harbor Agent packs (e.g., AI Act, FedRAMP, etc.)
          </p>
        </div>
      </div>
    </section>
  )
}

